import { render, staticRenderFns } from "./return-invoice.vue?vue&type=template&id=c4223036"
import script from "./return-invoice.vue?vue&type=script&lang=js"
export * from "./return-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports